import { render, staticRenderFns } from "./ManagmentDocumentsSupplier.vue?vue&type=template&id=466a1711"
import script from "./ManagmentDocumentsSupplier.vue?vue&type=script&lang=js"
export * from "./ManagmentDocumentsSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports